export const environment = {
    production: true,
    apiUrl: 'https://api.tensortag.com/api'
};
